import type { NavItem } from '@blueshift-ui/navigation';

import * as styles from './index.css';
import ACCOUNT_ROUTES from '../../../constants/account-routes';
import List from '@blueshift-ui/core/dist/components/list';
import { NavLink } from 'react-router-dom';
import Typography from '@blueshift-ui/theme/dist/components/typography';
import useBreakpoints from '@blueshift-ui/theme/dist/hooks/use-breakpoints';
import useIsVt4sClient from '../../../hooks/use-is-vt4s-client';

function SettingsNavPanel() {
  const { isLargeViewport } = useBreakpoints();
  const { isLoading: isVt4sClientLoading, hasAccess: isVt4sClient } = useIsVt4sClient();

  const helpCenterLink = isVt4sClient
    ? 'https://vt4s-parent.zendesk.com/hc/en-us'
    : 'https://vtcrt.zendesk.com/hc/en-us';

  if (!isLargeViewport) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Typography className={styles.heading} component="h2" variant="h6">
        Account
      </Typography>

      <List
        className={styles.list}
        items={[
          ...((isVt4sClientLoading || isVt4sClient
            ? []
            : [
                {
                  role: 'action',
                  text: 'Program',
                  component: NavLink,
                  componentProps: {
                    to: ACCOUNT_ROUTES.membership,
                  },
                },
                {
                  role: 'action',
                  text: 'Activity',
                  component: NavLink,
                  componentProps: {
                    to: ACCOUNT_ROUTES.activity,
                  },
                },
              ]) as NavItem[]),
          // Not implemented yet
          // {
          //   role: 'action',
          //   text: 'Payment',
          //   component: NavLink,
          //   componentProps: {
          //     to: ACCOUNT_ROUTES.payment,
          //   },
          // },
          {
            role: 'action',
            text: 'Account settings',
            component: NavLink,
            componentProps: {
              to: ACCOUNT_ROUTES.settings,
            },
          },
          {
            role: 'action',
            text: 'Help Center',
            component: 'a',
            componentProps: {
              to: helpCenterLink,
              target: '_blank',
            },
          },
        ]}
      />
    </div>
  );
}

export default SettingsNavPanel;
